import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";

export default function ReconcileReceiptDialog({ row, bankId, methodId, onDone }) {
  const [open, setOpen] = useState(false), [saving, setSaving] = useState(false);
  const blank = () => ({ gross_amount: String(row.bo_gross || ""), merchant_fee: "0",
    net_amount: String(row.bo_gross || ""), reference: "", note: "" });
  const [form, setForm] = useState(blank);
  useEffect(() => { if (open) setForm(blank()); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const set = (key, value) => {
    const next = { ...form, [key]: value };
    if (key === "gross_amount" || key === "merchant_fee")
      next.net_amount = String(Math.max(0, Number(next.gross_amount || 0) - Number(next.merchant_fee || 0)));
    setForm(next);
  };
  const confirm = async () => {
    if (!bankId || !form.reference.trim()) return toast.error("Bank account and reference are required");
    setSaving(true);
    try {
      await api.post("/sales/publicbank/manual-receipt", { branch_id: row.branch_id,
        txn_date: row.date, bank_account_id: bankId, method_id: methodId,
        gross_amount: Number(form.gross_amount), merchant_fee: Number(form.merchant_fee || 0),
        net_amount: Number(form.net_amount), reference: form.reference, note: form.note });
      toast.success("Bank received confirmed and reconciliation updated"); setOpen(false); onDone?.();
    } catch (error) { toast.error(apiError(error)); }
    finally { setSaving(false); }
  };
  return <Dialog open={open} onOpenChange={setOpen}>
    <DialogTrigger asChild><Button size="sm" variant="outline" className="h-7 mt-2">Confirm received</Button></DialogTrigger>
    <DialogContent className="max-w-lg"><DialogHeader><DialogTitle>Confirm bank received / reconciled</DialogTitle></DialogHeader>
      <div className="rounded-sm bg-slate-50 border p-3 text-xs text-slate-600">{row.date} · BO gross RM {Number(row.bo_gross || 0).toFixed(2)}. This creates an audited Received record under the selected bank.</div>
      <div className="grid grid-cols-3 gap-3">
        <div><Label className="text-xs">Merchant Gross</Label><Input type="number" min="0" step="0.01" value={form.gross_amount} onChange={(e) => set("gross_amount", e.target.value)} /></div>
        <div><Label className="text-xs">Fee / MDR</Label><Input type="number" min="0" step="0.01" value={form.merchant_fee} onChange={(e) => set("merchant_fee", e.target.value)} /></div>
        <div><Label className="text-xs">Net Received</Label><Input type="number" min="0" step="0.01" value={form.net_amount} onChange={(e) => set("net_amount", e.target.value)} /></div>
        <div className="col-span-3"><Label className="text-xs">Bank reference *</Label><Input value={form.reference} onChange={(e) => set("reference", e.target.value)} placeholder="Statement reference / receipt number" /></div>
        <div className="col-span-3"><Label className="text-xs">Note</Label><Input value={form.note} onChange={(e) => set("note", e.target.value)} placeholder="Optional explanation" /></div>
      </div>
      <DialogFooter><Button onClick={confirm} disabled={saving}>{saving ? "Confirming..." : "Confirm received / reconciled"}</Button></DialogFooter>
    </DialogContent>
  </Dialog>;
}
